// extracted by mini-css-extract-plugin
export default {"dynamic-preannotations-control":"lsf-dynamic-preannotations-control","waiting":"lsf-waiting"};